import { useEffect, useMemo, useState } from "react"
import { useSearchParams } from "react-router-dom";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { decryptData } from "../../../utils/encrypt";

export const useRequestAction = () => {
    const [searchParams] = useSearchParams();
    const actionparams = searchParams.get("action");
    const token = searchParams.get("token");
    const requestname = searchParams.get('requestname')
    const logDate = searchParams.get('logdate')
    const [message, setMessage] = useState({});

    useEffect(() => {
        sessionStorage.setItem("platform", "local");
        handleTimesheetAction();
    }, [actionparams, token])

    const handleTimesheetAction = async () => {
        try {
            const payload = {
                "request_name": decryptData(requestname?.split(" ").join("+")),
                "token": decryptData(token?.split(" ").join("+")) || "",
                "type": decryptData(actionparams?.split(" ").join("+")),
                "log_date": decryptData(logDate?.split(" ").join("+")) || ""
            }
            const res = await services.getInvokeRemote('POST', Urls('REQUESTAPPROVEREJECTBYEMAIL'), payload);
            if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                setMessage({ msg: res?.body?.errorMessage, color: "danger" });
            } else {
                setMessage({ msg: res?.body?.message, color: "success" });
            }

        } catch (error) {
            console.error("err:", error);
            setMessage({ msg: error?.response?.data?.errorMessage, color: "danger" });
        }
    }


    return useMemo(() => ({
        message
    }), [message])
}